import { QueryClient } from "@tanstack/react-query";

let queryClient: QueryClient | null = null;

export function getQueryClient(): QueryClient {
  if (!queryClient) {
    queryClient = new QueryClient({
      defaultOptions: {
        queries: {
          // Default garbage collection time - 24 hours
          gcTime: 24 * 60 * 60 * 1000,
          // Default stale time - 5 minutes
          staleTime: 5 * 60 * 1000,
          // Retry failed queries twice
          retry: 2,
          // Don't refetch on window focus to reduce API calls
          refetchOnWindowFocus: false,
          // Use offline-first approach - use cache when possible
          networkMode: 'offlineFirst',
          // Enable query deduplication to prevent duplicate requests
          structuralSharing: true,
        },
      },
    });
  }
  return queryClient;
}

export function setQueryClient(client: QueryClient): void {
  queryClient = client;
}
